import type { QueryClient } from "@tanstack/react-query";

/** Payment writes affect the ledger, receipt eligibility, supplier balances,
 * statements, payables, and the dashboard aggregate. Keep the cache contract
 * in one place because those queries use long-lived cached data. */
export function invalidateSupplierPaymentCaches(queryClient: QueryClient, _supplierId: string, _workspaceId: string) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: ["/api/maintenance/jobs/bootstrap"] }),
    queryClient.invalidateQueries({ queryKey: ["/api/maintenance/parts/bootstrap"] }),
    queryClient.invalidateQueries({ queryKey: ["cash-supplier-payment-options"] }),
    queryClient.invalidateQueries({ queryKey: ["branch-cash"] }),
    queryClient.invalidateQueries({ queryKey: ["suppliers"] }),
    queryClient.invalidateQueries({ queryKey: ["/api/suppliers"] }),
    queryClient.invalidateQueries({ queryKey: ["supplier-receipt"] }),
    queryClient.invalidateQueries({ queryKey: ["supplier-receipts"] }),
    queryClient.invalidateQueries({ queryKey: ["audit-entity", "supplier_payment"] }),
    queryClient.invalidateQueries({ queryKey: ["supplier-payments"] }),
    queryClient.invalidateQueries({ queryKey: ["supplier-payment"] }),
    queryClient.invalidateQueries({ queryKey: ["supplier-balance"] }),
    queryClient.invalidateQueries({ queryKey: ["supplier-payables"] }),
    queryClient.invalidateQueries({ queryKey: ["supplier-statement"] }),
    queryClient.invalidateQueries({ queryKey: ["/api/supplier-receipts"] }),
    queryClient.invalidateQueries({ queryKey: ["/api/suppliers/payables/summary"] }),
  ]);
}

/** Confirmation and corrections may create/reverse multiple cash allocations. */
export function invalidateSupplierReceiptCashCaches(queryClient: QueryClient, workspaceId: string) {
  return Promise.all([
    invalidateSupplierPaymentCaches(queryClient, "", workspaceId),
    queryClient.invalidateQueries({ queryKey: ["supplier-receipt-cash"] }),
    queryClient.invalidateQueries({ queryKey: ["branch-cash"] }),
    queryClient.invalidateQueries({ queryKey: ["receipt-cash-takings"] }),
    queryClient.invalidateQueries({ queryKey: ["audit-entity", "supplier_receipt"] }),
  ]);
}